import moment from "moment";
import requestGQL from "@/http/requests/request/request_v2_gql";
import userOptionGQL from "@/http/requests/agile/user_option_gql";
import { cloneDeep as lodashCloneDeep, get as lodashGet, isEmpty as lodashIsEmpty } from "lodash";
import cusConst from "../utils/constant";

export default {
	data() {
		return {
			isShowApproverDialogMixin: false,
			approveOrRejectStatusMixin: false,
			isShowCreateTodoDialogMixin: false,
			isShowRequestFormDialogMixin: false,
			isShowCancelRequestDialogMixin: false,
			isShowApproveOrRejectDialogMixin: false,

			requestsMixin: [],
			stepsDataMixin: [],
			requestTypesMixin: [],
			activeRequestMixin: {},
			activeStepIdMixin: null,
			cancelRequestDataMixin: {
				id: null,
				reason: ""
			},
			approverDialogDataMixin: {},
			todoFormDialogDataMixin: {},
			approveOrRejectDataMixin: {},
			listCountMixin: [],
			listFlagMixin: [{id:0, value:'NA'}].concat(cusConst.PICKER_MARK_COLORS),
		};
	},
	computed: {
		requestApproverDialogTitleMixin() {
			return `${this.$t("DetailRequest")} - ${lodashGet(this.approverDialogDataMixin, "reqtype.name") || ""}`;
		},
		requestApproverStepActiveIndex() {
			const currentFormStepStatus = this.approverDialogDataMixin.reqstatus;
			return this.approverDialogDataMixin.requestFormSteps.findIndex(requestFormStep => requestFormStep.id === currentFormStepStatus.id);
		},
		requestApproverDialogEditableMixin() {
			const currentFormStepStatus = lodashGet(this.approverDialogDataMixin, "reqstatus");
			return (
				(!this.approverDialogDataMixin.is_done &&
					!!this.approverDialogDataMixin.is_owner &&
					(this.requestApproverStepActiveIndex === 1 ||
						this.approverDialogDataMixin.is_dynamic ||
						(currentFormStepStatus.status === 0 && !!(currentFormStepStatus.controls && currentFormStepStatus.controls.length)))) ||
				false
			);
		},
		requestApproverDialogMappedAttachsDataObjMixin() {
			const mappedAttachObj = {};
			this.approverDialogDataMixin.attachs.forEach(attach => (mappedAttachObj[attach.id] = attach));
			return mappedAttachObj;
		}
	},
	methods: {
		handleShowRequestFormDialogMixin(requestItem) {
			this.handleSetActiveRequestDataByRequestItem(requestItem);
			this.toggleRequestFormDialogMixin(true);
		},
		handleShowApproverDialogMixin(requestItem) {
			this.handleSetActiveRequestDataByRequestItem(requestItem);
			const activeRequestType = requestItem.reqtype || {};
			let requestTypeSteps = activeRequestType.statuses || [];
			requestTypeSteps = requestTypeSteps.map(step => ({
				...step,
				controls: this.$helper.formatDynamicFormData(
					{
						data: step.data,
						controls: step.controls
					},
					"data",
					null
				).controls
			}));
			// filter last step
			this.approverDialogDataMixin = {
				...this.activeRequestMixin,
				requestFormSteps: [
					{
						status: null,
						id: `create-step-${activeRequestType.id}`,
						name: this.$t("CreateRequest"),
						controls: this.$helper.formatDynamicFormData({
							data: requestItem.data,
							controls: activeRequestType.controls
						}).controls
					},
					...requestTypeSteps
				]
			};
			this.toggleApproverDialogMixin(true);
		},
		async handleClickRowItemMixin(requestItem) {
			try {
				this.$vs.loading();

				try {
					const response = await requestGQL.getRequest(requestItem.id);
					let isActiveRequestApprovable = !!(response.reqstatus && response.reqstatus.status === 0 && response.can_edit);
					if (response.reqstatus && response.reqstatus.approverFillInfo) {
						if (response.data) {
							let dataObj = JSON.parse(response.data);
							if (dataObj) {
								if (!dataObj.hasOwnProperty("child")) {
									isActiveRequestApprovable = false;
								}
							}
						}
					}
					if (isActiveRequestApprovable) {
						this.handleShowApproverDialogMixin(response);
					} else {
						this.handleShowRequestFormDialogMixin(response);
					}
				} catch (error) {
					console.error("handleClickRowItemMixin", error);
				}
			} catch (error) {
				this.$helper.notifyError({ context: this, error });
			} finally {
				this.$nextTick(() => this.$vs.loading.close());
			}
		},
		async handleSetMarkedColorMixin(requestId, value, colorPickerRef) {
			try {
				this.$vs.loading();

				await userOptionGQL.updateUserOption({
					color: value,
					optionable_id: requestId,
					optionable_type: this.$constant.USER_OPTION_TYPE.REQUEST
				});

				if (colorPickerRef) {
					colorPickerRef[0].$el.click();
				}

				this.requestsMixin = this.requestsMixin.map(request => {
					if (request.id === requestId) {
						return {
							...request,
							user_option: {
								color: value
							}
						};
					}
					return request;
				});
			} catch (error) {
				this.$helper.notifyError({ context: this, error });
			} finally {
				this.$nextTick(() => this.$vs.loading.close());
			}
		},
		toggleRequestFormDialogMixin(val = false) {
			this.isShowRequestFormDialogMixin = val;
		},
		toggleCreateTodoFormDialogMixin(val = false) {
			this.isShowCreateTodoDialogMixin = val;
		},
		toggleCancelRequestDialogMixin(val = false) {
			this.isShowCancelRequestDialogMixin = val;
		},
		toggleApproveOrRejectDialogMixin(val = false) {
			this.isShowApproveOrRejectDialogMixin = val;
		},
		toggleApproverDialogMixin(val = false) {
			this.isShowApproverDialogMixin = val;
		},
		handleClickCreateTodoMixin(request) {
			this.todoFormDialogDataMixin = {
				relations: [
					{
						id: request.id,
						display: request.display_name,
						type: this.$constant.RELATION_MODELS.REQUEST
					}
				]
			};
			this.toggleCreateTodoFormDialogMixin(true);
		},
		async handleOnCreateTodoSuccessMixin() {
			if (this.isShowCreateTodoDialogMixin) {
				this.toggleCreateTodoFormDialogMixin();
			}
			if (this.isShowRequestFormDialogMixin) {
				// update request detail
				try {
					this.$vs.loading();
					const response = await requestGQL.getRequest(this.activeRequestMixin.id);
					this.activeRequestMixin = response;
				} catch (error) {
					this.$helper.notifyError({ context: this, error });
				} finally {
					this.$vs.loading.close();
				}
			}
		},
		async getRequestTypesMixin(isDisabledGlobalLoading = false) {
			try {
				if (!isDisabledGlobalLoading) {
					this.$vs.loading();
				}
				const response = await requestGQL.getRequestTypes({
					list_all: false
				});
				this.requestTypesMixin = response.data || [];
			} catch (error) {
				this.$helper.notifyError({ context: this, error });
			} finally {
				if (!isDisabledGlobalLoading) {
					this.$nextTick(() => this.$vs.loading.close());
				}
			}
		},
		async handleOnFocusSelectRequestTypesMixin(selectRequestTypeLoading) {
			const req_type_id = this.activeRequestMixin && this.activeRequestMixin.req_type_id;
			if (!req_type_id) {
				try {
					if (selectRequestTypeLoading) {
						selectRequestTypeLoading(true);
					}
					await this.getRequestTypesMixin(true);
				} catch (error) {
					this.$helper.notifyError({ context: this, error });
				} finally {
					if (selectRequestTypeLoading) {
						selectRequestTypeLoading(false);
					}
				}
			}
		},
		handleClickStepItemMixin(stepItem, initFormData) {
			const activeRequestType = this.activeRequestMixin.reqtype || {};
			const curentActiveStepIndex = this.stepsDataMixin.findIndex(step => step.id === stepItem.id);

			let parsedActiveFormData;
			// active form is parent or active step is last step in stepsDataMixin
			if (curentActiveStepIndex === 0 || curentActiveStepIndex === this.stepsDataMixin.length - 1) {
				parsedActiveFormData = this.$helper.formatDynamicFormData({
					data: this.activeRequestMixin.data,
					controls: activeRequestType.controls
				});
			} else {
				// active form is child
				const currentActiveStep = (activeRequestType.statuses || []).find(step => step.id === stepItem.id) || {};
				parsedActiveFormData = this.$helper.formatDynamicFormData(
					{
						data: currentActiveStep.data,
						controls: currentActiveStep.controls
					},
					"data",
					null
				);
			}

			let nextRequestReason = this.activeRequestMixin.request_reason;
			if (this.activeRequestMixin.request_reason !== initFormData.request_reason) {
				nextRequestReason = initFormData.request_reason;
			}
			this.activeStepIdMixin = stepItem.id;
			this.activeRequestMixin = {
				...this.activeRequestMixin,
				request_reason: nextRequestReason,
				activeFormData: this.getParsedStatusActiveFormData(this.activeRequestMixin, { ...parsedActiveFormData, id: this.activeStepIdMixin })
			};
		},
		getParsedRequestTypeSteps(requestTypeSteps = []) {
			const activeStepIndex = requestTypeSteps.findIndex(step => step.is_active);
			return requestTypeSteps.map((step, index) => ({
				id: step.id,
				name: step.name,
				// set status null to all steps behind active step
				status: activeStepIndex > -1 && index <= activeStepIndex ? step.status : null,
				color: step.color || null
			}));
		},
		handleChangeRequestTypeMixin(selectedRequestType) {
			const req_type_id = selectedRequestType && selectedRequestType.value;
			if (!req_type_id) {
				this.stepsDataMixin = [];
				this.activeStepIdMixin = null;
				this.activeRequestMixin = {};
			} else {
				const activeRequestType = this.requestTypesMixin.find(requestType => requestType.id === req_type_id) || {};
				const parsedActiveFormData = this.$helper.formatDynamicFormDataStructure(activeRequestType);

				this.stepsDataMixin = [
					{
						id: `create-step-${activeRequestType.id}`,
						name: this.$t("CreateRequest"),
						status: this.$constant.REQUEST_STATUSES.WAITING
					},
					...this.getParsedRequestTypeSteps(activeRequestType.statuses || []),
					{
						id: `completed-step-${activeRequestType.id}`,
						name: this.$t(`RequestStepComplete`),
						status: null
					}
				];
				this.activeStepIdMixin = this.stepsDataMixin[0].id;
				this.activeRequestMixin = {
					...this.activeRequestMixin,
					req_type_id,
					activeFormData: this.getParsedStatusActiveFormData({}, { ...parsedActiveFormData, id: this.activeStepIdMixin })
				};
			}
		},
		handleSetInitRequestFormDialogMixin() {
			const resetDataObj = {
				stepsDataMixin: [],
				requestTypesMixin: [],
				activeRequestMixin: {},
				activeStepIdMixin: null,
				todoFormDialogDataMixin: {}
			};
			// reset data when clost dialog
			Object.keys(resetDataObj).forEach(key => {
				this[key] = resetDataObj[key];
			});
		},
		getParsedStatusActiveFormData(requestItem, activeFormData) {
			const activeFormDataIndex = this.stepsDataMixin.findIndex(step => step.id === activeFormData.id);
			const activeStepData = this.stepsDataMixin.find(step => step.id === activeFormData.id);
			let canUpdate;
			if (activeFormDataIndex === 0) {
				// is first step
				canUpdate = requestItem.id ? requestItem.can_update : true; // set true when in create mode
			}
			if (activeFormDataIndex > 0) {
				// is child step
				if (requestItem.reqstatus && requestItem.reqstatus.approverFillInfo) {
					// nguoi duyet la nguoi nhap thong tin chu khong phai nguoi de xuat
					canUpdate =
						!requestItem.is_owner &&
						requestItem.can_fill_extra_info &&
						!requestItem.is_cancel &&
						(this.stepsDataMixin[activeFormDataIndex].status === 0 || this.stepsDataMixin[activeFormDataIndex].status === null);
				} else {
					canUpdate = requestItem.is_owner && !requestItem.is_cancel && (this.stepsDataMixin[activeFormDataIndex].status === 0 || this.stepsDataMixin[activeFormDataIndex].status === null);
				}
			}

			return {
				...lodashCloneDeep(activeFormData),
				canUpdate,
				status: activeFormDataIndex === 0 ? requestItem.status : activeStepData.status
			};
		},
		async handleExportDataMixin() {
			try {
				this.$vs.loading();
				const response = await requestGQL.exportRequest(this.activeRequestMixin.id);
				const fileName = response.split("/");
				await this.handleDownloadFile({
					path: response,
					file_name: fileName[fileName.length - 1]
				});
			} catch (error) {
				this.$helper.notifyError({ context: this, error });
			} finally {
				this.$nextTick(() => this.$vs.loading.close());
			}
		},
		async handleClickRecreateRequestMenuMixin(requestItem) {
			try {
				this.$vs.loading();
				const response = await requestGQL.getRequest(requestItem.id);
				await this.handleClickRecreateRequestMixin(response);
				if (!this.isShowRequestFormDialogMixin) {
					this.toggleRequestFormDialogMixin(true);
				}
			} catch (error) {
				this.$helper.notifyError({ context: this, error });
			} finally {
				this.$nextTick(() => this.$vs.loading.close());
			}
		},
		async handleClickRecreateRequestMixin(requestData) {
			await this.getRequestTypesMixin();
			const req_type_id = requestData && requestData.req_type_id;
			const activeRequestType = this.requestTypesMixin.find(requestType => requestType.id === req_type_id) || {};
			const parsedActiveFormData = this.$helper.formatDynamicFormData({
				data: requestData.data,
				controls: activeRequestType.controls
			});

			this.stepsDataMixin = [
				{
					id: `create-step-${activeRequestType.id}`,
					name: this.$t("CreateRequest"),
					status: this.$constant.REQUEST_STATUSES.WAITING
				},
				...this.getParsedRequestTypeSteps(activeRequestType.statuses || []),
				{
					id: `completed-step-${activeRequestType.id}`,
					name: this.$t(`RequestStepComplete`),
					status: null
				}
			];
			this.activeStepIdMixin = this.stepsDataMixin[0].id;
			this.activeRequestMixin = {
				...requestData,
				...this.activeRequestMixin,
				id: null,
				req_type_id,
				is_cancel: false,
				activeFormData: this.getParsedStatusActiveFormData(requestData, { ...parsedActiveFormData, id: this.activeStepIdMixin })
			};
			console.log("this.handleClickRecreateRequestMixin: ");
			console.log(this.stepsDataMixin);
		},
		formatStepConfigData(configData) {
			return {
				content: lodashGet(configData, "content"),
				relations: (lodashGet(configData, "relations") || []).map(option => ({ id: option.id, type: option.type }))
			};
		},
		async handleClickConfirmApproveOrRejectDialogMixin(data) {
			try {
				this.$vs.loading();
				let response;
				if (this.approveOrRejectStatusMixin === true) {
					const approvePayload = {
						id: data.id,
						note: data.reason
					};

					if (data.notificationStepsConfig) {
						approvePayload.step_status = {
							name: data.notificationStepsConfig.name,
							notifications: {
								approvers: this.formatStepConfigData(lodashGet(data.notificationStepsConfig, "config.approversConfig")),
								reject_notifications: this.formatStepConfigData(lodashGet(data.notificationStepsConfig, "config.rejectedNotificationConfig")),
								approve_notifications: this.formatStepConfigData(lodashGet(data.notificationStepsConfig, "config.approvedNotificationConfig"))
							}
						};
					}

					response = await requestGQL.approvedRequest(approvePayload);
				} else {
					response = await requestGQL.rejectedRequest({ id: data.id, reason: data.reason });
				}

				this.$helper.notifySuccess({
					context: this,
					options: {
						text: this.$t(`${this.approveOrRejectStatusMixin ? "ApproveRequestSuccessful" : "RejectRequestSuccessful"}`)
					}
				});
				this.toggleApproveOrRejectDialogMixin(false);

				// update active request in list
				this.requestsMixin = this.requestsMixin.map(request => {
					if (request.id === response.id) {
						return response;
					}
					return request;
				});
				if (this.isShowApproverDialogMixin) {
					this.toggleApproverDialogMixin(false);
				}
				if (this.isShowRequestFormDialogMixin) {
					this.handleSetActiveRequestDataByRequestItem(response);
				}
			} catch (error) {
				this.$helper.notifyError({ context: this, error });
			} finally {
				this.$nextTick(() => this.$vs.loading.close());
			}
		},
		handleClickApproveOrRejectMixin(id, isApprovedStatus = false, approveWithNotificationStepsConfig) {
			this.approveOrRejectStatusMixin = isApprovedStatus;
			this.toggleApproveOrRejectDialogMixin(true);
			this.approveOrRejectDataMixin = {
				id,
				reason: "",
				notificationStepsConfig: approveWithNotificationStepsConfig
			};
		},
		handleClickCancelRequestMixin(requestId) {
			this.cancelRequestDataMixin = {
				reason: "",
				id: requestId
			};
			this.toggleCancelRequestDialogMixin(true);
		},
		handleSetActiveRequestDataByRequestItem(requestItem) {
			const activeRequestType = requestItem.reqtype || {};
			const currentActiveStep = (activeRequestType.statuses || []).find(step => step.is_active) || {};
			let requestTypeSteps = this.getParsedRequestTypeSteps(activeRequestType.statuses || []);
			const curentActiveStepIndex = requestTypeSteps.findIndex(step => step.id === currentActiveStep.id);
			const isRequestDone = requestItem.is_done;
			const isRequestCanceled = requestItem.is_cancel;
			if (isRequestCanceled) {
				requestTypeSteps = requestTypeSteps.map(step => {
					return {
						...step,
						status: null
					};
				});
			}

			let parsedActiveFormData;
			// when not any child active => active form is parent || request complete || request is canceled
			if (curentActiveStepIndex === -1 || isRequestDone || isRequestCanceled) {
				parsedActiveFormData = this.$helper.formatDynamicFormData({
					data: requestItem.data,
					controls: activeRequestType.controls
				});
			} else {
				// active form is child
				try {
					parsedActiveFormData = this.$helper.formatDynamicFormData(
						{
							data: currentActiveStep.data,
							controls: currentActiveStep.controls
						},
						"data",
						null
					);
				} catch (error) {
					console.error("handleSetActiveRequestDataByRequestItem 2-2", error);
				}
			}

			this.stepsDataMixin = [
				{
					id: `create-step-${activeRequestType.id}`,
					name: this.$t("CreateRequest"),
					status: isRequestCanceled ? this.$constant.REQUEST_STATUSES.CANCELED : this.$constant.REQUEST_STATUSES.APPROVED
				},
				...requestTypeSteps,
				{
					id: `completed-step-${activeRequestType.id}`,
					name: this.$t(`RequestStepComplete`),
					status: isRequestDone ? this.$constant.REQUEST_STATUSES.APPROVED : null
				}
			];
			console.log("this.handleSetActiveRequestDataByRequestItem: ");
			console.log(this.stepsDataMixin);

			if (isRequestDone) {
				// request complete => active last step in stepsDataMixin
				this.activeStepIdMixin = this.stepsDataMixin[this.stepsDataMixin.length - 1].id;
			} else if (isRequestCanceled) {
				// request is canceled
				this.activeStepIdMixin = this.stepsDataMixin[0].id;
			} else {
				this.activeStepIdMixin = currentActiveStep.id;
			}

			this.activeRequestMixin = {
				...requestItem,
				req_type_id: requestItem.req_type_id,
				activeFormData: this.getParsedStatusActiveFormData(requestItem, { ...parsedActiveFormData, id: this.activeStepIdMixin })
			};
			// update active request in list
			this.requestsMixin = this.requestsMixin.map(request => {
				if (request.id === requestItem.id) {
					return requestItem;
				}
				return request;
			});
		},
		async handleCreateOrUpdateRequest(payload, relationsData) {
			let response;
			const activeStepIndex = this.stepsDataMixin.findIndex(step => step.id === this.activeStepIdMixin);
			if (activeStepIndex === 0) {
				// Parent Form
				if (payload && payload.id) {
					response = await requestGQL.updateRequest(payload);
				} else {
					response = await requestGQL.submitRequest({
						...payload,
						relations: relationsData
					});
				}
			} else {
				// Child Form
				response = await requestGQL.submitNextRequest({
					...payload,
					data: JSON.stringify({
						status_id: payload.req_status_id,
						data: JSON.parse(payload.data)
					})
				});
			}

			return response;
		},
		async handleClickConfirmCancelRequestMixin(data) {
			try {
				this.$vs.loading();
				const response = await requestGQL.cancelRequest({
					id: data.id,
					reason: data.reason
				});

				this.$helper.notifySuccess({
					context: this,
					options: {
						text: this.$t("CancelRequestSuccessful")
					}
				});

				// update active request in list
				this.requestsMixin = this.requestsMixin.map(request => {
					if (request.id === response.id) {
						return response;
					}
					return request;
				});
				if (this.isShowRequestFormDialogMixin) {
					this.toggleRequestFormDialogMixin(false);
				}
				this.toggleCancelRequestDialogMixin(false);
			} catch (error) {
				this.$helper.notifyError({ context: this, error });
			} finally {
				this.$nextTick(() => this.$vs.loading.close());
			}
		},
		async handleClickSubmitRequestFormDialogMixin(requestData, dynamicStepConfig, relationsData, resolve) {
			try {
				this.$vs.loading();
				const mappedFormData = {};
				requestData.activeFormData.controls.forEach(field => {
					mappedFormData[field.id] = field.value;
					if (field.control === this.$constant.request.control.datetime && field.value) {
						mappedFormData[field.id] = moment(field.value).isValid() ? moment(field.value).toISOString() : field.value;
					}
					if (!lodashIsEmpty(field.value) && field.control === this.$constant.request.control.relation && field.value.every(item => typeof item === "object")) {
						mappedFormData[field.id] = field.value.map(item => item.id);
					}
				});

				const payload = {
					id: requestData.id,
					req_type_id: requestData.req_type_id,
					req_status_id: requestData.req_status_id,
					request_reason: requestData.request_reason,
					data: JSON.stringify(mappedFormData)
				};

				const selectedRequestType = this.requestTypesMixin.find(requestType => requestType.id === requestData.req_type_id) || {};
				const isDynamicRequest =
					(requestData && !requestData.id && selectedRequestType && selectedRequestType.statuses && lodashIsEmpty(selectedRequestType.statuses)) ||
					(requestData && requestData.id && requestData.is_dynamic);
				if (isDynamicRequest) {
					payload.step_status = {
						name: dynamicStepConfig.name,
						notifications: {
							approvers: this.formatStepConfigData(lodashGet(dynamicStepConfig, "config.approversConfig")),
							reject_notifications: this.formatStepConfigData(lodashGet(dynamicStepConfig, "config.rejectedNotificationConfig")),
							approve_notifications: this.formatStepConfigData(lodashGet(dynamicStepConfig, "config.approvedNotificationConfig"))
						}
					};
				}

				const response = await this.handleCreateOrUpdateRequest(payload, relationsData);
				this.handleSetActiveRequestDataByRequestItem(response);
				resolve(response);
				if (this.isShowApproverDialogMixin) {
					this.handleShowApproverDialogMixin(response);
				}
			} catch (error) {
				this.$helper.notifyError({ context: this, error });
			} finally {
				this.$nextTick(() => this.$vs.loading.close());
			}
		},
		async handleClickDuplicateRequestMixin(requestId) {
			try {
				this.$vs.loading();
				const response = await requestGQL.duplicateRequest(requestId);
				this.handleShowRequestFormDialogMixin(response);
				this.$helper.notifySuccess({
					context: this,
					options: {
						text: this.$t("DuplicateRequestSuccessful")
					}
				});
			} catch (error) {
				this.$helper.notifyError({ context: this, error });
			} finally {
				this.$nextTick(() => this.$vs.loading.close());
			}
		},
		async getRequestStatusCount() {
			const response = await requestGQL.getRequestListCount();
			if (response) {
				this.listCountMixin = response;
			}
		}
	}
};
